"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledContainer = exports.StyledCarouselWrapper = exports.StyleCarouselContainer = exports.StylePaginationBarWrapper = void 0;
const components_core_1 = require("@volkswagen-onehub/components-core");
exports.StylePaginationBarWrapper = components_core_1.styled.div `
  width: 100%;
  padding-bottom: 4px;
`;
exports.StyleCarouselContainer = components_core_1.styled.div `
  width: 100%;
`;
exports.StyledCarouselWrapper = components_core_1.styled.div `
  ${(props) => !props.singleelement && 'margin-right: -355px;'}
  @media (min-width: ${components_core_1.Breakpoints.b560}px) {
    margin-right: -330px;
  }
`;
exports.StyledContainer = components_core_1.styled.div `
  width: 100%;
  height: 100%;
  padding-right: ${(props) => props.singleelement ? 0 : '10px'};
  @media (min-width: ${components_core_1.Breakpoints.b560}px) {
    padding-right: 40px;
  }
`;
